var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#04B7B1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1020_52191",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1020_52191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 12H19V10C19 9.16667 18.7083 8.45833 18.125 7.875C17.5417 7.29167 16.8333 7 16 7C15.1667 7 14.4583 7.29167 13.875 7.875C13.2917 8.45833 13 9.16667 13 10H11C11 8.61667 11.4877 7.43733 12.463 6.462C13.4377 5.48733 14.6167 5 16 5C17.3833 5 18.5627 5.48733 19.538 6.462C20.5127 7.43733 21 8.61667 21 10V12H22C22.55 12 23.021 12.1957 23.413 12.587C23.8043 12.979 24 13.45 24 14V24C24 24.55 23.8043 25.021 23.413 25.413C23.021 25.8043 22.55 26 22 26H10C9.45 26 8.97933 25.8043 8.588 25.413C8.196 25.021 8 24.55 8 24V14C8 13.45 8.196 12.979 8.588 12.587C8.97933 12.1957 9.45 12 10 12ZM10 24H22V14H10V24ZM16 21C16.55 21 17.021 20.8043 17.413 20.413C17.8043 20.021 18 19.55 18 19C18 18.45 17.8043 17.979 17.413 17.587C17.021 17.1957 16.55 17 16 17C15.45 17 14.9793 17.1957 14.588 17.587C14.196 17.979 14 18.45 14 19C14 19.55 14.196 20.021 14.588 20.413C14.9793 20.8043 15.45 21 16 21Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.ae45d1ad626e0bcdf646f31b53078f0a.svg";
export { ForwardRef as ReactComponent };